import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const TicketingReply = ({ data, handleLinkSubmit, handleDraftClick }) => {
  const [reply, setReply] = useState([]);

  function getHeaderText(ticket) {
    if (ticket?.role) {
      if (ticket.role === "CANDIDATE") {
        return "Candidate Reply";
      } else {
        return "Admin Reply";
      }
    }
  }

  useEffect(() => {
    var grouped_reply = [];
    var last_reply = null;
    var latest_group = [];
    data.forEach((reply) => {
      if (!last_reply) {
        last_reply = reply;
        latest_group.push(reply);
      } else {
        if (last_reply.role != reply.role) {
          grouped_reply.push(latest_group);
          latest_group = [];
        }
        latest_group.push(reply);
        last_reply = reply;
      }
    });
    if (latest_group.length > 0) {
      grouped_reply.push(latest_group);
    }
    setReply(grouped_reply);
  }, [data]);

  return (
    <>
      {reply.length > 0 ? (
        <>
          {reply.map((group, index) => (
            <div
              key={`card-${index}`}
              className="card mt-2"
              style={{ marginLeft: "20px", marginRight: "20px" }}
            >
              <div className="card-header" style={{ fontWeight: "bold" }}>
                <div className="d-flex justify-content-between">
                  <span className="mr-auto">{getHeaderText(group[0])}</span>
                  <span>Attachments</span>
                </div>
              </div>
              <div className="card-body">
                {group.map((comment, commentIndex) => (
                  <React.Fragment key={commentIndex}>
                    <div className="row mt-2">
                      <div className="col-md-8 mb-2">
                        <div className="form-group">
                          {comment.comment && (
                            <div style={{ fontWeight: "bold" }}>
                              {comment.comment}
                            </div>
                          )}
                          {comment.commentDate && (
                            <>
                              <div>{comment.commentDate}</div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 d-flex justify-content-end">
                        {comment.attachment && (
                          <button
                            className="btn btn-link"
                            rel="noopener noreferrer"
                            onClick={() => {
                              handleLinkSubmit(comment?.attachment);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            attachment
                          </button>
                        )}
                      </div>
                      {group.length - 1 - commentIndex != 0 && <hr />}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="ms-4 mt-3">No Ticket History Available</div>
      )}
    </>
  );
};

TicketingReply.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      comment: PropTypes.string,
      attachments: PropTypes.arrayOf(PropTypes.string),
      commentDate: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
  handleLinkSubmit: PropTypes.func.isRequired,
};

export default TicketingReply;
